/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~cartzillagb/util'

class SellerBlockPlaceholder extends Component {

	render() {
		const {
			slidesToShow = 3,
			slidesToShowLaptop = 3,
			slidesToShowTablet = 3,
			slidesToShowMobile = 1,
		} = this.props

		const output = (
			<div className="row">
				<div className="col-lg-4 text-center text-lg-left pb-3 pt-lg-2">
					<div className="d-inline-block text-left w-100">
						<div className="media media-ie-fix align-items-center pb-3">
							<div className="img-thumbnail rounded-circle position-relative">
								<div className="rounded-circle bg-secondary" style={ { width: '6.375rem', height: '6.375rem' } }></div>
							</div>
							<div className="media-body pl-3">
								<div className="font-size-lg progress w-50 mb-3"></div>
								<div className="d-block text-muted font-size-ms pt-1 pb-2 progress w-75 mb-3"></div>
								<span className="btn btn-primary btn-sm w-50">
									<div className="progress bg-transparent"></div>
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-8">
					<ul className={ classnames( [
						'place-holder',
						'row',
						'list-unstyled',
						'products',
						'products-group',
						'no-gutters',
						'mb-0',
						'w-100',
						`columns-${slidesToShow}`,
						`columns-lg-${slidesToShowLaptop}`,
						`columns-md-${slidesToShowTablet}`,
						`columns-sm-${slidesToShowMobile}`,
					], {} ) }>
						{ range( 1, ( slidesToShow ) + 1 ).map( i => {
							return(
								<li className="product cartzilla-product-placeholder" key={ `product-${i}` }>
									<div className="cartzilla-product-grid">
										<div className="card product-card">
											<div className="badge badge-shadow w-25">
												<div className="progress bg-light"></div>
											</div>
											<div className="card-img-top d-block overflow-hidden w-100 position-relative" style={ { paddingTop:'100%' } }>
												<div className="iframe-full-height bg-muted"></div>
											</div>
											<div className="card-body py-2">
												<div className="woocommerce-loop-product__categories progress w-25 mb-2">
												</div>
												<h3 className="woocommerce-loop-product__title product-title font-size-sm progress w-50 mb-3">
												</h3>
												<div className="d-flex justify-content-between progress w-25">
												</div>
											</div>
										</div>
										<hr className="d-sm-none" />
									</div>
								</li>
							)
						} ) }
					</ul>
				</div>
			</div>
		)

		return output
	}
}

export default SellerBlockPlaceholder